import { CollectionNames } from '../utils/collectionNames';
import { getSDSCollectionItems } from 'mini-sds-gateway';

export const getBXUserCustomPropertiesItems = async (): Promise<any> =>
    getSDSCollectionItems(CollectionNames.ExtensionUserCustomProperties);
